import { render, staticRenderFns } from "./VerifyStep3.vue?vue&type=template&id=473420f4&"
import script from "./VerifyStep3.vue?vue&type=script&lang=js&"
export * from "./VerifyStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports